/* ============================================================
   FP Cart Drawer (Evergreen / Holiday)
   DOC: "FattyPack Cart Drawer Strategy: Evergreen + Holiday"

   This file does NOT replace the theme's cart logic (theme.dev.js still
   adds, changes, removes and re-renders the drawer). After every re-render
   it reads two JSON blocks and draws the parts that depend on the promo mode:

     #fpcd-config        (snippets/cart-drawer.liquid)  theme settings
     [data-fpcd-state]   (snippets/fp-cart-drawer-banner.liquid) the cart as
                         Shopify priced it: packs, wallet, total, savings, deal

   It draws:
     1. the sticky banner (step bar -> gift bar, with the slide animation)
     2. the savings callout ("You're saving $X with DEAL")
     3. Buy More, Save More prices + FREE badges (next pack free?)
     4. You May Also Like placement (under the accessories)
   and handles:
     5. the drawer's quantity steppers, debounced 400ms (DOC build notes),
        including the paid / FREE rows of one cart line
     6. the ADD buttons of the new cards (same add flow as the theme upsell)

   Everything runs once (window.__fpcdInit) and works by event delegation,
   so re-renders never stack listeners.
   ============================================================ */
(function () {
  if (window.__fpcdInit) return;
  window.__fpcdInit = true;

  var ROOT = '#drawer-cart';
  var DEBOUNCE = 400;
  var FPCD = (window.FPCD = window.FPCD || { mode: '', state: null });

  /* ---------- helpers ---------- */
  function $(sel, ctx) { return (ctx || document).querySelector(sel); }
  function $$(sel, ctx) { return Array.prototype.slice.call((ctx || document).querySelectorAll(sel)); }
  function drawer() { return $(ROOT); }
  function esc(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }
  /* "Add [1 more] FattyPack" -> green "1 more" */
  function rich(s) {
    return esc(s).replace(/\[([^\]]+)\]/g, '<span class="fpcd-banner__hl">$1</span>');
  }
  function readJSON(el) {
    if (!el) return null;
    try { return JSON.parse(el.textContent); } catch (e) { return null; }
  }

  var CFG = null;
  function cfg() {
    if (!CFG) CFG = readJSON(document.getElementById('fpcd-config')) || { modes: {} };
    return CFG;
  }

  /* Shopify money format, cents -> "$20.00" (trim: "$20" / "$9.99") */
  function money(cents, trim) {
    var fmt = cfg().moneyFormat || '${{amount}}';
    var v = (Number(cents) || 0) / 100;
    var whole = Math.round(v * 100) % 100 === 0;
    return fmt.replace(/\{\{\s*(\w+)\s*\}\}/, function (_, k) {
      if (k === 'amount_no_decimals' || k === 'amount_no_decimals_with_comma_separator') {
        return Math.round(v).toLocaleString('en-US');
      }
      var d = trim && whole ? 0 : 2;
      var out = v.toLocaleString('en-US', { minimumFractionDigits: d, maximumFractionDigits: d });
      if (k === 'amount_with_comma_separator') out = out.replace(/,/g, '#').replace('.', ',').replace(/#/g, '.');
      return out;
    });
  }

  /* ---------- 0. promo mode ---------- */
  /* "2026-11-27 00:00" in the store time zone ("-0500") -> Date */
  function parseDate(str, tz) {
    if (!str) return null;
    var m = String(str).trim().match(/^(\d{4})-(\d{2})-(\d{2})(?:[ T](\d{1,2}):(\d{2}))?/);
    if (!m) return null;
    var off = /^[+-]\d{4}$/.test(tz || '') ? tz.slice(0, 3) + ':' + tz.slice(3) : 'Z';
    var hh = ('0' + (m[4] || '0')).slice(-2);
    var d = new Date(m[1] + '-' + m[2] + '-' + m[3] + 'T' + hh + ':' + (m[5] || '00') + ':00' + off);
    return isNaN(d.getTime()) ? null : d;
  }
  function currentMode() {
    var c = cfg();
    if (c.mode === 'holiday') return 'holiday';
    if (c.mode === 'scheduled') {
      var now = Date.now();
      var a = parseDate(c.holidayStart, c.tz);
      var b = parseDate(c.holidayEnd, c.tz);
      if (a && now >= a.getTime() && (!b || now <= b.getTime())) return 'holiday';
    }
    return 'evergreen';
  }
  function modeCfg(mode) {
    var m = (cfg().modes || {})[mode] || {};
    m.freeSet = String(m.free || '').split(',').map(function (n) { return parseInt(n, 10); }).filter(function (n) { return n > 0; });
    m.steps = parseInt(m.steps, 10) || 5;
    m.unlock = parseInt(m.unlock, 10) || m.steps;
    return m;
  }

  /* ---------- 1. banner ---------- */
  var lastKind = { evergreen: null, holiday: null };
  var slideTimer = null;

  function stepsHTML(m) {
    var html = '';
    for (var i = 1; i <= m.steps; i++) {
      html += '<li class="fpcd-step' + (i === 1 ? ' fpcd-step--first' : '') + '" data-step="' + i + '">' +
        '<span class="fpcd-step__n">' + i + '</span>' +
        (m.freeSet.indexOf(i) > -1 ? '<span class="fpcd-step__tag">' + esc(cfg().freeLabel || 'Free') + '</span>' : '') +
        '</li>';
    }
    return '<ol class="fpcd-steps" data-fpcd-steps>' + html + '</ol>';
  }
  function giftsHTML() {
    var gifts = (cfg().gifts || []).filter(function (g) { return Number(g.amount) > 0; });
    var html = gifts.map(function (g, i) {
      return '<li class="fpcd-step' + (i === 0 ? ' fpcd-step--first' : '') + '" data-gift="' + (Number(g.amount) * 100) + '">' +
        '<span class="fpcd-step__n">' + esc(money(Number(g.amount) * 100, true)) + '</span>' +
        '<span class="fpcd-step__tag">' + esc(g.label || '') + '</span></li>';
    }).join('');
    return '<ol class="fpcd-steps fpcd-steps--gifts" data-fpcd-gifts>' + html + '</ol>';
  }
  function row(m, key) {
    var rows = m.rows || {};
    if (rows[key] && (rows[key][0] || rows[key][1])) return rows[key];
    /* closest lower pack count that has copy */
    var n = parseInt(key, 10);
    while (!isNaN(n) && n > 0) { n--; if (rows[n] && rows[n][0]) return rows[n]; }
    return ['', ''];
  }

  function renderBanner(state, mode) {
    var d = drawer();
    var slot = d && $('[data-fpcd-banner-slot]', d);
    if (!slot) return;
    var c = cfg();
    if (c.banner === false || !state || !state.items) {
      slot.hidden = true;
      return;
    }
    slot.hidden = false;

    var m = modeCfg(mode);
    var unlocked = !!state.wallet || state.packs >= m.unlock;
    var kind = unlocked ? 'gift' : 'steps';
    var key = state.wallet ? 'wallet' : unlocked ? 'unlocked' : String(Math.min(state.packs, m.unlock - 1));
    var copy = row(m, key);

    var banner = $('.fpcd-banner', slot);
    var sig = mode + '|' + m.steps + '|' + m.free;
    if (!banner || banner.getAttribute('data-sig') !== sig) {
      slot.innerHTML =
        '<div class="fpcd-banner" data-sig="' + esc(sig) + '">' +
          '<p class="fpcd-banner__title" data-fpcd-title></p>' +
          '<p class="fpcd-banner__sub" data-fpcd-sub></p>' +
          '<div class="fpcd-banner__bars">' +
            '<div class="fpcd-banner__track" data-fpcd-track>' +
              '<div class="fpcd-banner__pane">' + stepsHTML(m) + '</div>' +
              '<div class="fpcd-banner__pane">' + giftsHTML() + '</div>' +
            '</div>' +
          '</div>' +
        '</div>';
      banner = $('.fpcd-banner', slot);
      lastKind[mode] = null;
    }

    $('[data-fpcd-title]', banner).innerHTML = rich(copy[0]);
    var sub = $('[data-fpcd-sub]', banner);
    sub.innerHTML = rich(copy[1]);
    sub.hidden = !copy[1];

    /* gift steps fill from the cart total after discounts (gifts are $0) */
    $$('[data-gift]', banner).forEach(function (li) {
      li.classList.toggle('is-done', Number(state.total) >= Number(li.getAttribute('data-gift')));
    });

    function fillSteps(n) {
      $$('[data-step]', banner).forEach(function (li) {
        li.classList.toggle('is-done', Number(li.getAttribute('data-step')) <= n);
      });
    }

    clearTimeout(slideTimer);
    var animate = c.animate !== false && lastKind[mode] === 'steps' && kind === 'gift';
    if (animate) {
      /* DOC: the last box fills green, then the bar slides to the gift bar */
      banner.classList.remove('is-gift');
      fillSteps(m.steps);
      slideTimer = setTimeout(function () { banner.classList.add('is-gift'); }, 550);
    } else {
      fillSteps(kind === 'gift' ? m.steps : state.packs);
      banner.classList.toggle('is-gift', kind === 'gift');
      if (lastKind[mode] === null) {
        /* first paint: no slide */
        banner.classList.add('is-instant');
        requestAnimationFrame(function () { requestAnimationFrame(function () { banner.classList.remove('is-instant'); }); });
      }
    }
    banner.setAttribute('data-kind', kind);
    lastKind[mode] = kind;
  }

  /* ---------- 2. savings callout ---------- */
  var TAG_ICON = '<svg class="fpcd-callout__icon" viewBox="0 0 16 16" aria-hidden="true" focusable="false"><path d="M8.6 1.5H13a1.5 1.5 0 0 1 1.5 1.5v4.4a1 1 0 0 1-.3.7l-6.5 6.5a1 1 0 0 1-1.4 0L1.9 10.2a1 1 0 0 1 0-1.4l6.5-6.5a1 1 0 0 1 .2-.8z" fill="none" stroke="currentColor" stroke-width="1.2" stroke-linejoin="round"/><circle cx="11" cy="5" r="1.1" fill="currentColor"/></svg>';

  function renderCallout(state, mode, scope) {
    var el = $('[data-fpcd-callout]', scope);
    if (!el) return;
    var c = cfg();
    /* DOC "Callout math": pack-line discounts + wallet compare-at savings in Holiday */
    var amount = Number(state.packSavings) || 0;
    if (mode === 'holiday') amount += Number(state.walletSavings) || 0;
    var deal = mode === 'holiday' && state.wallet ? (c.holidayWalletDeal || 'HOLIDAY SALE') : (state.deal || '');
    if (c.callout === false || amount <= 0 || !deal) {
      el.hidden = true;
      el.innerHTML = '';
      return;
    }
    var text = String(c.calloutText || "You're saving {amount} with {deal}")
      .replace('{amount}', money(amount, true))
      .replace('{deal}', deal);
    el.innerHTML = TAG_ICON + '<span class="fpcd-callout__text">' + esc(text) + '</span>';
    el.hidden = false;
  }

  /* ---------- 3. Buy More, Save More prices + FREE badges ---------- */
  function renderCards(state, mode, scope) {
    var sec = $('[data-fpcd-buymore]', scope);
    if (!sec) return;
    var m = modeCfg(mode);
    var packs = Number(state.packs) || 0;
    var badgeOn = sec.getAttribute('data-badge') !== 'false';
    var compareOn = sec.getAttribute('data-compare') !== 'false';
    var unlocked = !!state.wallet || packs >= m.unlock;

    /* DOC: FREE badge "only when the next pack added is free" */
    var nextFree = badgeOn && !unlocked && m.freeSet.indexOf(packs + 1) > -1;
    var pct = state.wallet ? Number(cfg().walletPct) || 0 : packs >= m.unlock ? Number(m.unlockPct) || 0 : 0;

    sec.classList.toggle('is-next-free', nextFree);
    $$('[data-fpcd-card]', sec).forEach(function (card) {
      var price = Number(card.getAttribute('data-price')) || 0;
      var cmp = Number(card.getAttribute('data-compare')) || 0;
      var now = price, was = 0;
      if (nextFree) { now = 0; was = price; }
      else if (pct > 0) { now = Math.round(price * (100 - pct) / 100); was = price; }
      else if (compareOn && cmp > price) { was = cmp; }

      var p = $('[data-fpcd-card-price]', card);
      if (p) p.innerHTML = '<span class="fpcd-card__now">' + esc(money(now)) + '</span>' + (was > now ? '<s class="fpcd-card__was">' + esc(money(was)) + '</s>' : '');
      var b = $('[data-fpcd-card-free]', card);
      if (b) b.hidden = !nextFree;
    });
  }

  /* ---------- 4. You May Also Like under the accessories ---------- */
  function placeYmal(items) {
    var d = drawer();
    var slot = d && $('[data-fpcd-ymal-slot]', d);
    if (!slot || !items) return;
    slot.innerHTML = '';
    var fresh = $('[data-fpcd-ymal-src]', items);
    if (fresh) slot.appendChild(fresh);
  }

  /* Checkout button total as in the design ("$60.00", no currency code).
     The theme adds " USD" when it refreshes the total; this runs right after it. */
  function renderCheckoutTotal(state) {
    var fin = $(ROOT + ' [data-cart-final]');
    if (fin && state && typeof state.total === 'number') fin.textContent = money(state.total);
  }

  /* ---------- render after every theme re-render ---------- */
  function render() {
    var d = drawer();
    var items = d && $('[data-line-items]', d);
    if (!items) return;
    var state = readJSON($('[data-fpcd-state]', items));
    if (!state) return;
    var mode = currentMode();
    FPCD.mode = mode;
    FPCD.state = state;
    d.setAttribute('data-fpcd-mode', mode);

    renderBanner(state, mode);
    renderCallout(state, mode, items);
    renderCards(state, mode, items);
    placeYmal(items);
    renderCheckoutTotal(state);
    document.dispatchEvent(new CustomEvent('fpcd:render', { detail: { mode: mode, state: state } }));
  }

  function watch() {
    var d = drawer();
    var items = d && $('[data-line-items]', d);
    if (!items || items.__fpcdWatch) return;
    items.__fpcdWatch = true;
    /* the theme replaces the line items with innerHTML -> nodes are added */
    new MutationObserver(function (records) {
      for (var i = 0; i < records.length; i++) {
        if (records[i].addedNodes.length) { render(); return; }
      }
    }).observe(items, { childList: true });
    /* re-check the mode (time) whenever the drawer opens */
    d.addEventListener('theme:drawer:open', function () { if (FPCD.state) render(); });
    render();
  }

  /* Empty cart: the theme shows its empty state without re-rendering the items */
  document.addEventListener('theme:cart:change', function (e) {
    var cart = e.detail && e.detail.cart;
    if (cart && cart.item_count === 0) {
      var slot = drawer() && $('[data-fpcd-banner-slot]', drawer());
      if (slot) slot.hidden = true;
      var y = drawer() && $('[data-fpcd-ymal-slot]', drawer());
      if (y) y.innerHTML = '';
    }
  });

  /* ---------- 5. every cart change made in the drawer: ONE queue ----------
     Why (root cause of "cart cleared" / "removed items come back"):
       - the theme sent each change on its own and silently DROPPED a change that
         came while another one was still running (CartItems.updating);
       - the gift +/-, the ADD buttons, the steppers and the theme each sent their
         own requests and re-rendered from their own (older) /cart.js snapshot;
       - the drawer HTML (?section_id=api-cart-items) was fetched once per change and
         the responses could arrive out of order, so an OLDER cart was drawn last;
       - the theme picks "empty cart" from the last cart it was told about, so an
         old / wrong snapshot showed the empty state while products were still in
         the cart (and they "came back" on the next refresh).
     Now:
       - remove, steppers, typed qty, FREE-row trash, gift +/- and ADD all go
         through one queue: one request at a time, in click order, nothing dropped;
       - every change targets the line by its key (exact line, never "line N");
       - when the queue is empty the real cart is read once and the drawer is
         re-rendered once from it (theme:cart:change + theme:cart:reload);
       - only the newest drawer HTML is ever drawn (see "latest drawer HTML" below).
     The clicks are taken on window + capture (before apps such as EG Auto Add to
     Cart see them), same reason as the ADD buttons below. */
  var timers = {};
  var pending = {};
  var adding = 0;
  var inFlight = 0;
  var queue = Promise.resolve();
  var settleSeq = 0;
  /* true while a change is waiting, queued or running; the free-gift script
     (sections/cart-checkpoints.liquid) waits for it */
  FPCD.busy = function () { return adding > 0 || inFlight > 0 || Object.keys(timers).length > 0; };

  function later(id, fn) {
    clearTimeout(timers[id]);
    timers[id] = setTimeout(function () { delete timers[id]; fn(); }, DEBOUNCE);
  }

  function postJSON(path, body) {
    return fetch(routes() + path, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(body)
    }).then(function (res) {
      return res.json().catch(function () { return {}; }).then(function (data) {
        if (!res.ok) throw new Error((data && (data.description || data.message)) || 'Could not update cart, please reload');
        return data;
      });
    });
  }

  function showError(msg) {
    var errors = $(ROOT + ' [data-form-errors]');
    if (!errors) return;
    errors.innerHTML = '<p>' + esc(msg) + '</p>';
    errors.style.display = 'block';
  }
  function clearError() {
    var errors = $(ROOT + ' [data-form-errors]');
    if (errors && errors.style.display !== 'none') { errors.style.display = 'none'; errors.innerHTML = ''; }
  }

  /* same loading look as the theme (row load bar + no clicks on that row) */
  function lockRow(el) {
    var row = el && el.closest && el.closest('[data-cart-item]');
    if (!row) return;
    var bar = $('[data-item-loadbar]', row);
    if (bar) bar.style.display = 'block';
    row.classList.add('cart__item--updating');
    row.style.pointerEvents = 'none';
  }
  function unlockRows() {
    $$(ROOT + ' .cart__item--updating').forEach(function (row) {
      var bar = $('[data-item-loadbar]', row);
      if (bar) bar.style.display = 'none';
      row.classList.remove('cart__item--updating');
      row.style.pointerEvents = '';
    });
  }

  /* After the last queued change: re-render from the real cart (see "One source of
     truth" below) and release the rows. */
  function settle() {
    requestSync(true, true);
    clearTimeout(settle.t);
    settle.t = setTimeout(function () { if (inFlight === 0) unlockRows(); }, 5000);   /* safety only */
  }

  /* ---------- One source of truth for what the drawer shows ----------
     Root cause of "the drawer shows an empty cart, then the items come back":
     the theme (CartItems) draws the drawer, and decides "empty / not empty", from
     the LAST cart object it was handed in a theme:cart:change event. Many scripts
     send that event (theme, product page, bundle builder, gift checkpoints, upsells,
     apps), each with its own snapshot taken at a different moment, and each also
     asks for its own re-render (theme:cart:reload). A snapshot that was old, partial
     or not a cart at all made the theme show the empty state / old lines until the
     next event fixed it, and every script re-rendered the drawer again.

     Now, inside this file only:
       - every theme:cart:change / theme:cart:reload, from any script, is collected
         (taken first, on window + capture) and NOT passed to the theme as is;
       - after a short pause (a burst of events = one pass) the real cart is read
         once from Shopify (/cart.js, no cache);
       - the theme gets ONE theme:cart:change with that real cart (only when the cart
         really changed) and ONE theme:cart:reload, so the drawer is drawn once, from
         the real cart. It can only show "empty" when Shopify's cart is empty.
       - one pass at a time; events that arrive during a pass make exactly one more
         pass; identical carts are not sent again, so nothing can loop.
     No request of any other script (EG app, Intelligems, theme) is touched; only the
     two theme events above are coalesced. Every other listener of those events still
     receives them (with the real cart), a few ms later. */
  var SYNC = '__fpcdSync';
  var syncTimer = null, syncing = false, syncAgain = false, wantReload = false, forceReload = false;
  var lastSig = null, renderedSig = null;
  var syncTimes = [];

  function cartSig(c) {
    if (!c || !c.items) return '';
    return [c.token, c.item_count, c.total_price, c.items.map(function (i) {
      return i.key + ':' + i.quantity + ':' + i.final_line_price;
    }).join('|')].join('#');
  }
  function emit(name, detail) {
    var ev = new CustomEvent(name, { detail: detail, bubbles: true });
    ev[SYNC] = true;
    document.dispatchEvent(ev);
  }
  function requestSync(reload, force) {
    if (reload) wantReload = true;
    if (force) forceReload = true;
    clearTimeout(syncTimer);
    /* a burst of events -> one pass; never more than ~6 passes in 3 s */
    var now = Date.now();
    syncTimes = syncTimes.filter(function (t) { return now - t < 3000; });
    syncTimer = setTimeout(runSync, syncTimes.length >= 6 ? 800 : 120);
  }
  function runSync() {
    if (syncing) { syncAgain = true; return; }
    if (inFlight > 0) return;                       /* the drawer queue calls settle() when done */
    syncing = true;
    syncTimes.push(Date.now());
    var reload = wantReload, force = forceReload;
    wantReload = false;
    forceReload = false;
    fetch(routes() + 'cart.js', { headers: { Accept: 'application/json' }, cache: 'no-store', credentials: 'same-origin' })
      .then(function (r) { if (!r.ok) throw new Error('cart.js ' + r.status); return r.json(); })
      .then(function (cart) {
        if (!cart || !cart.items) throw new Error('no cart');
        var sig = cartSig(cart);
        var changed = sig !== lastSig;
        lastSig = sig;
        if (changed) emit('theme:cart:change', { cart: cart });
        /* re-draw only when it shows something new (or after a drawer change, to release its rows) */
        if (changed || force || (reload && sig !== renderedSig)) {
          renderedSig = sig;
          emit('theme:cart:reload');
        }
      })
      .catch(function () {
        /* could not read the cart: let the theme refresh itself once, as before */
        if (reload || force) emit('theme:cart:reload');
      })
      .then(function () {
        syncing = false;
        if (syncAgain || wantReload || forceReload) { syncAgain = false; requestSync(false); }
      });
  }
  window.addEventListener('theme:cart:change', function (e) {
    if (e[SYNC]) return;
    e.stopImmediatePropagation();
    requestSync(false);
  }, true);
  window.addEventListener('theme:cart:reload', function (e) {
    if (e[SYNC]) return;
    e.stopImmediatePropagation();
    requestSync(true);
  }, true);
  FPCD.sync = function () { requestSync(true); };

  /* task() returns a promise; tasks run one after another */
  function enqueue(task) {
    inFlight++;
    var run = queue.then(function () { clearError(); return task(); })
      .catch(function (err) {
        console.error('FP cart drawer:', err);
        showError(err && err.message ? err.message : String(err));
      })
      .then(function () {
        inFlight = Math.max(0, inFlight - 1);
        if (inFlight === 0) settle();
      });
    queue = run;
    return run;
  }

  /* set the exact quantity of one cart line (by its key) */
  function changeLine(key, qty, el) {
    if (!key) return;
    lockRow(el);
    return enqueue(function () {
      return postJSON('cart/change.js', { id: key, quantity: Math.max(0, qty) }).catch(function (err) {
        /* The line is no longer in the cart with this key (another script / app changed
           the cart after the drawer was drawn). Nothing to change: the drawer is simply
           re-drawn from the real cart when the queue settles, no error for the customer. */
        if (/no valid id or line parameter/i.test(String(err && err.message))) return;
        throw err;
      });
    });
  }
  FPCD.changeLine = changeLine;

  function toInt(v, d) { var n = parseInt(v, 10); return isNaN(n) ? d : n; }

  /* One handler for every quantity / remove control inside the drawer */
  function handleCartClick(t) {
    /* a) paid / FREE rows of one line: both change the same cart line */
    var step = t.closest('[data-fpcd-step]');
    if (step) {
      var box = step.closest('[data-fpcd-qty]');
      if (!box) return;
      var key = box.getAttribute('data-key');
      var real = $(ROOT + ' [data-fpcd-real="' + CSS.escape(key) + '"]');
      var shown = $('.quantity__input', box);
      if (!real || !shown) return;
      var delta = toInt(step.getAttribute('data-fpcd-step'), 0);
      var cur = toInt(shown.value, 0);
      if (cur + delta < 0) return;
      shown.value = cur + delta;
      pending[key] = (pending[key] || 0) + delta;
      later('k:' + key, function () {
        var next = Math.max(0, toInt(real.value, 0) + (pending[key] || 0));
        delete pending[key];
        real.value = next;
        changeLine(key, next, box);
      });
      return;
    }

    /* b) FREE row trash: keep only the paid units */
    var rmFree = t.closest('[data-fpcd-remove-free]');
    if (rmFree) {
      var k = rmFree.getAttribute('data-fpcd-remove-free');
      var r = $(ROOT + ' [data-fpcd-real="' + CSS.escape(k) + '"]');
      if (!r) return;
      changeLine(k, toInt(r.getAttribute('data-paid'), 0), rmFree);
      return;
    }

    /* c) free gift row (app "_Gifted" line): + adds a separate paid line, - removes the gift */
    var gAdd = t.closest('[data-fpcd-gift-add]');
    if (gAdd) {
      lockRow(gAdd);
      var vid = Number(gAdd.getAttribute('data-fpcd-gift-add'));
      if (vid) enqueue(function () { return postJSON('cart/add.js', { items: [{ id: vid, quantity: 1 }] }); });
      return;
    }
    var gRm = t.closest('[data-fpcd-gift-rm]');
    if (gRm) { changeLine(gRm.getAttribute('data-fpcd-gift-rm'), 0, gRm); return; }

    /* d) trash icon of any line */
    var rm = t.closest('[data-remove-key]');
    if (rm) {
      var rk = rm.getAttribute('data-remove-key');
      var input = $(ROOT + ' [data-update-cart="' + CSS.escape(rk) + '"]');
      if (input) input.value = 0;
      clearTimeout(timers['i:' + rk]); delete timers['i:' + rk];   /* a waiting +/- is replaced by the remove */
      changeLine(rk, 0, rm);
      return;
    }

    /* e) the theme's own steppers: one request per burst of taps */
    var btn = t.closest('[data-quantity-selector] .quantity__button');
    if (btn) {
      var wrap = btn.closest('[data-quantity-selector]');
      var qi = wrap && $('[data-update-cart]', wrap);
      if (!qi) return;
      var min = toInt(qi.getAttribute('min'), 0);
      var v = toInt(qi.value, 0) + (btn.hasAttribute('data-increase-quantity') ? 1 : -1);
      qi.value = Math.max(min, v);
      var ik = qi.getAttribute('data-update-cart');
      later('i:' + ik, function () { changeLine(ik, toInt(qi.value, 0), qi); });
    }
  }

  var CART_CONTROLS = [
    '[data-fpcd-step]', '[data-fpcd-remove-free]', '[data-fpcd-gift-add]', '[data-fpcd-gift-rm]',
    '[data-remove-key]', '[data-quantity-selector] .quantity__button'
  ].map(function (sel) { return ROOT + ' ' + sel; }).join(',');

  function onCartClick(e) {
    var t = e.target && e.target.closest && e.target.closest(CART_CONTROLS);
    if (!t) return;
    e.preventDefault();
    e.stopImmediatePropagation();     /* no theme / app handler sends its own request */
    handleCartClick(t);
  }
  /* typed quantity ("3" + Enter / blur) */
  function onCartInput(e) {
    var input = e.target && e.target.closest && e.target.closest(ROOT + ' [data-update-cart]');
    if (!input || input.type === 'hidden') return;
    e.stopImmediatePropagation();
    var key = input.getAttribute('data-update-cart');
    clearTimeout(timers['i:' + key]); delete timers['i:' + key];
    changeLine(key, toInt(input.value, 0), input);
  }
  window.addEventListener('click', onCartClick, true);
  window.addEventListener('change', onCartInput, true);
  /* the early guard in snippets/cart-drawer.liquid (registered before app scripts)
     stops these clicks first and hands them over here */
  document.addEventListener('fpcd:cart-click', function (e) { if (e.detail && e.detail.el) handleCartClick(e.detail.el); });
  document.addEventListener('fpcd:cart-input', function (e) { if (e.detail && e.detail.el) onCartInput({ target: e.detail.el, stopImmediatePropagation: function () {} }); });

  /* ---------- latest drawer HTML only ----------
     The theme fetches ?section_id=api-cart-items on every reload. When several reloads
     overlap (theme, gift app, upsells...) an older response could arrive last and draw
     an old cart (removed items back, wrong qty, empty state). Every caller now gets the
     newest response, so the drawer always shows the latest Shopify cart. */
  (function () {
    var orig = window.fetch;
    if (!orig || orig.__fpcdLatest) return;
    var latest = null;
    function urlOf(input) { return typeof input === 'string' ? input : (input && input.url) || ''; }
    var wrapped = function (input, init) {
      if (urlOf(input).indexOf('section_id=api-cart-items') === -1) return orig.apply(this, arguments);
      var entry = { p: orig.apply(this, arguments) };
      entry.body = entry.p.then(function (r) {
        return r.clone().text().then(function (text) { return { text: text, status: r.status, statusText: r.statusText, headers: r.headers }; });
      });
      latest = entry;
      return entry.p.then(function first(res) {
        if (latest === entry) return res;
        var newer = latest;
        return newer.body.then(function (b) {
          if (newer !== latest) return first(res);
          return new Response(b.text, { status: b.status, statusText: b.statusText, headers: b.headers });
        });
      });
    };
    wrapped.__fpcdLatest = true;
    window.fetch = wrapped;
  })();

  /* ---------- 6. ADD buttons on the new cards ---------- */
  function routes() {
    var r = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    return r.charAt(r.length - 1) === '/' ? r : r + '/';
  }

  /* ADD buttons in the drawer. Taken on window + capture (before any app sees the
     click) and stopped there: the EG Auto Add to Cart app's "BuyNowInterceptor"
     can treat such a click as "Buy now" and EMPTY the cart before adding the item
     (same reason as the Instafeed fix in snippets/fp-instafeed-drawer.liquid). */
  function addFromButton(btn) {
    if (!btn) return;
    if (Date.now() < dragClickUntil) { dragClickUntil = 0; return; }   /* end of a row drag, not a click */
    if (btn.disabled || btn.classList.contains('is-loading')) return;

    var id = Number(btn.getAttribute('data-fpcd-add'));
    if (!id) return;
    btn.classList.add('is-loading');
    btn.setAttribute('aria-busy', 'true');
    adding++;

    /* Wait & Save (pre-order) wallet: add it with its selling plan, so the cart
       gets exactly the price the card shows */
    var item = { id: id, quantity: 1 };
    var plan = Number(btn.getAttribute('data-fpcd-plan')) || 0;
    if (plan) item.selling_plan = plan;

    enqueue(function () {
      return postJSON('cart/add.js', { items: [item] }).then(function (data) {
        document.dispatchEvent(new CustomEvent('reloadCart', { detail: data }));
      });
    }).then(function () {
      adding = Math.max(0, adding - 1);
      btn.classList.remove('is-loading');
      btn.removeAttribute('aria-busy');
    });
  }

  window.addEventListener('click', function (e) {
    var btn = e.target.closest && e.target.closest(ROOT + ' [data-fpcd-add]');
    if (!btn) return;
    e.preventDefault();
    e.stopImmediatePropagation();
    addFromButton(btn);
  }, true);

  /* Same click, caught even earlier by the small guard in layout/theme.liquid
     (registered before any app script loads), which stops it and hands it here. */
  document.addEventListener('fpcd:add', function (e) {
    addFromButton(e.detail && e.detail.btn);
  });

  /* ---------- Horizontal scroll rows (Buy More, accessories, You May Also Like) ----------
     Works for any row in the drawer that is set to "Horizontal scroll" and actually
     overflows, so it keeps working after every cart re-render (delegated, bound once).
     - Mouse (desktop): drag to scroll. A mouse can't swipe a native scroll row and the
       scrollbar is hidden, so without this the row could not be moved. After the drag
       the row eases to the nearest card; the click that ends a drag is ignored, so a
       drag never adds a product by accident.
     - Touch (mobile): the theme's drawer scroll lock cancels touchmove inside the drawer
       on iOS, which also killed the sideways swipe. For a sideways gesture that starts
       in a scroll row the touchmove is kept away from that lock (stopPropagation only,
       never preventDefault), so the browser's own smooth swipe + snap runs. Up/down
       gestures still reach the theme as before. */
  function hScroller(t) {
    var root = drawer();
    if (!root || !t || t.nodeType !== 1 || !root.contains(t)) return null;
    for (var el = t; el && el !== root; el = el.parentElement) {
      var ox = getComputedStyle(el).overflowX;
      if ((ox === 'auto' || ox === 'scroll') && el.scrollWidth > el.clientWidth + 1) return el;
    }
    return null;
  }

  function snapNearest(el) {
    var kids = el.children;
    if (!kids.length) { el.style.scrollSnapType = ''; return; }
    var base = kids[0].offsetLeft;
    var max = el.scrollWidth - el.clientWidth;
    var best = el.scrollLeft, dist = Infinity;
    for (var i = 0; i < kids.length; i++) {
      var pos = Math.min(kids[i].offsetLeft - base, max);
      var d = Math.abs(pos - el.scrollLeft);
      if (d < dist) { dist = d; best = pos; }
    }
    if (Math.abs(el.scrollLeft - max) < 2) best = max;
    el.scrollTo({ left: best, behavior: 'smooth' });
    clearTimeout(el.__fpcdSnapT);
    el.__fpcdSnapT = setTimeout(function () { el.style.scrollSnapType = ''; }, 450);
  }

  var drag = null;
  var dragClickUntil = 0;

  document.addEventListener('pointerdown', function (e) {
    if (e.pointerType !== 'mouse' || e.button !== 0) return;
    if (e.target.closest && e.target.closest('input, textarea, select')) return;
    var el = hScroller(e.target);
    if (!el) return;
    drag = { el: el, id: e.pointerId, x: e.clientX, left: el.scrollLeft, moved: false };
  }, true);

  document.addEventListener('pointermove', function (e) {
    if (!drag || e.pointerId !== drag.id) return;
    var dx = e.clientX - drag.x;
    if (!drag.moved) {
      if (Math.abs(dx) < 6) return;              /* small moves stay a normal click */
      drag.moved = true;
      clearTimeout(drag.el.__fpcdSnapT);
      drag.el.style.scrollSnapType = 'none';     /* snap would fight the drag */
      drag.el.classList.add('fpcd-is-dragging');
      if (window.getSelection) window.getSelection().removeAllRanges();
    }
    drag.el.scrollLeft = drag.left - dx;
    e.preventDefault();
  }, true);

  function endDrag(e) {
    if (!drag || (e && e.pointerId !== drag.id)) return;
    var d = drag;
    drag = null;
    if (!d.moved) return;
    d.el.classList.remove('fpcd-is-dragging');
    dragClickUntil = Date.now() + 350;
    snapNearest(d.el);
  }
  document.addEventListener('pointerup', endDrag, true);
  document.addEventListener('pointercancel', endDrag, true);

  /* the click that ends a drag must not press ADD / open a product */
  window.addEventListener('click', function (e) {
    if (Date.now() < dragClickUntil && hScroller(e.target)) {
      e.preventDefault();
      e.stopImmediatePropagation();
      dragClickUntil = 0;
    }
  }, true);

  /* no native image / link ghost-drag inside a scroll row */
  document.addEventListener('dragstart', function (e) {
    if (hScroller(e.target)) e.preventDefault();
  }, true);

  var swipe = null;
  window.addEventListener('touchstart', function (e) {
    swipe = null;
    if (e.touches.length !== 1) return;
    var el = hScroller(e.target);
    if (el) swipe = { x: e.touches[0].clientX, y: e.touches[0].clientY, dir: '' };
  }, { capture: true, passive: true });

  window.addEventListener('touchmove', function (e) {
    if (!swipe || e.touches.length !== 1) return;
    if (!swipe.dir) {
      var dx = Math.abs(e.touches[0].clientX - swipe.x);
      var dy = Math.abs(e.touches[0].clientY - swipe.y);
      if (dx < 4 && dy < 4) { e.stopPropagation(); return; }   /* direction not known yet */
      swipe.dir = dx >= dy ? 'x' : 'y';
    }
    if (swipe.dir === 'x') e.stopPropagation();
  }, { capture: true, passive: true });

  function endSwipe() { swipe = null; }
  window.addEventListener('touchend', endSwipe, { capture: true, passive: true });
  window.addEventListener('touchcancel', endSwipe, { capture: true, passive: true });

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', watch);
  else watch();

  /* exposed for QA in the console: FPCD.render(), FPCD.currentMode() */
  FPCD.render = render;
  FPCD.currentMode = currentMode;
})();
